import request from '../request'
import qs from 'query-string'


export function getRecordLog(recordId: number) {
    return request.get(`/api/records/logs?recordId=${recordId}`)
  }